module.exports = __webpack_public_path__ + "img/graphic-1.bddc0554.png";